import type { ReactElement } from 'react';
import { CmarkdownLabelText } from '../Cmarkdowntext/CmarkdownLabelText';
import { Ctext } from '../Ctext';
import { TextPreset } from '@/constants/componentPresets';
import { ColorType } from '@/theme/colors';
import { pxToRem } from '@/theme/spacing';
import { LEGEND_DOT_SIZE } from './piechart-constants';
import type { PieChartArc, PieChartHoverChange } from './piechart-types';
interface PieChartLegendProps {
    arcs: ReadonlyArray<PieChartArc>;
    hoveredIndex: number | null;
    onHoveredIndexChange: PieChartHoverChange;
}
export function PieChartLegend({ arcs, hoveredIndex, onHoveredIndexChange, }: PieChartLegendProps): ReactElement {
    return (
      <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: pxToRem(6),
        }}>
        {arcs.map((arc, index) => (<PieChartLegendItem arc={arc} hoveredIndex={hoveredIndex} index={index} key={arc.debugIdentity} onHoveredIndexChange={onHoveredIndexChange}/>))}
      </div>
    );
}
interface PieChartLegendItemProps {
    arc: PieChartArc;
    hoveredIndex: number | null;
    index: number;
    onHoveredIndexChange: PieChartHoverChange;
}
function PieChartLegendItem({ arc, hoveredIndex, index, onHoveredIndexChange, }: PieChartLegendItemProps): ReactElement {
    return (
      <div onMouseEnter={() => onHoveredIndexChange(index)} onMouseLeave={() => onHoveredIndexChange(null)} style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: pxToRem(8),
            opacity: hoveredIndex == null || hoveredIndex === index ? 1 : 0.4,
            transition: 'opacity 150ms ease-out',
            cursor: 'default',
        }}>
        <div style={{
            width: LEGEND_DOT_SIZE,
            height: LEGEND_DOT_SIZE,
            borderRadius: LEGEND_DOT_SIZE / 2,
            backgroundColor: arc.color,
            boxShadow: `0 0 6px ${arc.color}80`,
            flexShrink: 0,
        }}/>
      <CmarkdownLabelText content={arc.slice.label} size={14} color={ColorType.White} opacity={0.8} paragraphStyle={{ marginBottom: 0 }} textStyle={{ whiteSpace: 'nowrap' }}/>
      <Ctext preset={TextPreset.Mild} size={13} color={ColorType.White} opacity={0.5} style={{ whiteSpace: 'nowrap' }}>
        {arc.percentage}%
      </Ctext>
      </div>
    );
}
